import { useParams } from "react-router-dom"
import { Container, Row, Col } from "react-bootstrap"
import { useGetAdditionalServiceByIdQuery } from "../../../services/bClientApi"
import AdditionalServiceEntry from "../../../Components/AdditionalService/AdditionalServiceEntry/AdditionalServiceEntry"
import DataLogList from "../../../Components/DataLogs/DataLogList"

export default function AdditionalServicePage() {
    const { additionalServiceId = '' } = useParams()

    const {
        data,
        error,
        isLoading
    } = useGetAdditionalServiceByIdQuery(additionalServiceId, { skip: !additionalServiceId })
    const additionalServiceData = data || {}

    return (
        <Container>
            <Row>
                <Col
                    xs={12}
                    lg={9}
                >
                    <h1>Additional Service Details</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}

                    {additionalServiceId && additionalServiceData && additionalServiceData._id && !isLoading && (
                        <AdditionalServiceEntry
                            additionalServiceData={additionalServiceData}
                            fullView={true}
                        />
                    )}
                </Col>

                <Col
                    xs={12}
                    lg={3}
                >
                    <DataLogList
                        dataType="additionalService"
                        dataId={additionalServiceId}
                    />
                </Col>
            </Row>
        </Container>
    )
}
